import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let QualityExamine = class QualityExamine extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.searchForm = {
            keyword: '',
            displayOption: 0,
            applicationDates: [],
            timer: null,
            examineResults: [],
            sortBy: '',
            sortType: '',
            orderType: '',
            dataSource: '',
        };
        this.salesOrderType = [
            {
                value: '销售',
                color: '#4caf50',
            },
            {
                value: '试用',
                color: '#44b2d2',
            },
            {
                value: '研发',
                color: '#ff9800',
            },
        ];
        this.examineResultType = [
            {
                text: '未检',
                value: 0,
                color: '#9E9E9E',
            },
            {
                text: '通过',
                value: 1,
                color: '#4caf50',
            },
            {
                text: '未通过',
                value: 2,
                color: '#F44336',
            },
        ];
        this.orderStatusType = [
            {
                text: '全部',
                value: 0,
            },
            {
                text: '待入库',
                value: 1,
            },
            {
                text: '已入库',
                value: 2,
            },
        ];
        this.dataSourceType = [
            {
                text: '全部',
                value: '',
                color: '',
            },
            {
                text: '生产',
                value: 0,
                color: '#00BCD4',
            },
            {
                text: '退库',
                value: 1,
                color: '#8BC34A',
            },
        ];
        this.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
        };
        this.headers = [
            {
                text: '质检编号',
                align: 'left',
                sortable: false,
                value: 'orderNumber',
                width: '200',
            },
            {
                text: '申请来源',
                align: 'center',
                sortable: false,
                value: 'dataSource',
                width: '90',
            },
            {
                text: '生产/退库单号',
                align: 'left',
                sortable: false,
                value: 'salesOrderNumber',
                width: '160',
            },
            {
                text: '生产单类型',
                align: 'left',
                sortable: false,
                value: 'salesOrderType',
                width: '100',
            },
            {
                text: '设备编号',
                align: 'left',
                sortable: false,
                value: 'deviceCode',
                width: '140',
            },
            {
                text: '产品名称',
                align: 'left',
                sortable: false,
                value: 'productName',
                width: '140',
            },
            // {
            //   text: '产品系列',
            //   align: 'left',
            //   sortable: false,
            //   value: 'serial',
            //   width: '140',
            // },
            {
                text: '产品型号',
                align: 'left',
                sortable: false,
                value: 'model',
                width: '115',
            },
            // {
            //     text: "数量（单位）",
            //     align: "left",
            //     sortable: false,
            //     value: "quantity",
            //     width: "120",
            // },
            {
                text: '申请人',
                align: 'left',
                sortable: false,
                value: 'applicant',
                width: '115',
            },
            {
                text: '申请日期',
                align: 'center',
                sortable: false,
                value: 'applicationDate',
                width: '115',
            },
            {
                text: '质检结果',
                align: 'center',
                sortable: false,
                value: 'examineResult',
                width: '100',
            },
            {
                text: '质检日期',
                align: 'center',
                sortable: false,
                value: 'examineDate',
                width: '115',
            },
            {
                text: '订单状态',
                align: 'center',
                sortable: false,
                value: 'orderStatus',
                width: '100',
            },
            {
                text: '操作',
                align: 'left',
                sortable: false,
                value: 'action',
                width: '200',
            },
        ];
        this.desserts = [];
        this.dialogAuditResult = {
            visible: false,
            loading: false,
            title: '审核质检单',
            operType: 'pass',
            form: false,
            formData: {},
        };
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        // 产品信息
        this.productList = [];
        this.dialogProduct = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
    }
    get dateRangeText() {
        let str = '';
        if (this.searchForm.applicationDates.length > 0) {
            str = this.searchForm.applicationDates.join(' ~ ');
        }
        return str;
    }
    /**
     * 根据value获取数组对象
     * @param array
     * @param value
     */
    getArrayObjByValue(array, value) {
        const data = array.find((o) => o.value === value);
        return data || {};
    }
    async mounted() {
        const that = this;
        await that.skipParams();
        that.getDataList();
        that.initUserList(); // 加载人员字典
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchForm.timer);
        that.searchForm.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    /**
     * 查询质检单数据
     */
    async getDataList() {
        const that = this;
        that.loading = true;
        try {
            const res = await that.axios.get('/api/erp/order/quality', {
                params: {
                    page: that.pagination.pageNow,
                    limit: typeof that.pagination.everyPageCount === 'number' ? that.pagination.everyPageCount : that.pagination.sumDetail,
                    keyword: that.searchForm.keyword,
                    applicationStartDate: (that.searchForm.applicationDates.length > 0 && that.searchForm.applicationDates[0]) || '',
                    applicationEndDate: (that.searchForm.applicationDates.length > 1 && that.searchForm.applicationDates[1]) || '',
                    orderType: !/全部|所有/.test(that.searchForm.orderType) ? that.searchForm.orderType : '',
                    orderStatus: !/全部|所有/.test(that.searchForm.orderStatus) ? that.searchForm.orderStatus : '',
                    dataSource: (that.searchForm.dataSource && `${that.searchForm.dataSource.value}`) || '',
                    examineResult: (that.searchForm.examineResults && that.searchForm.examineResults.toString()) || '',
                },
            });
            that.desserts = res.data.result || [];
            // 处理签订日期数据
            // that.desserts.forEach((item: any) => {
            //     if (item.applicationDate) {
            //         item.applicationDate = new Date(item.applicationDate).format("yyyy-MM-dd");
            //     }
            // });
            that.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.pagination.everyPageCount) || 1;
            that.pagination.pageCount = pageCount;
            if (that.pagination.pageNow > pageCount) {
                that.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.loading = false;
        }
    }
    async initUserList() {
        const that = this;
        if ((that.userInfoDic.list || []).length > 0) {
            // 已查询过就不在添加
            return;
        }
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    // 产品列表
    async getProductList() {
        const that = this;
        // 这里对产品要求不搞，只需要查询一次即可
        if (that.productList.length === 0) {
            const res = await that.axios.get('/api/erp/inventory/statistics');
            that.productList = (res.data && res.data.result) || [];
        }
    }
    /**
     * 入库确认事件
     */
    async putStorageForm(row) {
        const that = this;
        that.dialogProduct.visible = true;
        that.dialogProduct.formData.storeType = '0';
        that.dialogProduct.title = '入库确认';
        that.dialogProduct.formData.inboundDate = new Date().format('yyyy-MM-dd hh:mm:ss');
        that.dialogProduct.formData.remark = `${row.remark}\n质检编号${row.orderNumber}审核通过入库`;
        that.dialogProduct.formData.salesOrderId = row.salesOrderId; // 生产或退库订单id
        that.dialogProduct.formData.salesOrderNumber = row.salesOrderNumber; // 生产或退库单号
        that.dialogProduct.formData.salesOrderType = row.salesOrderType; // 生产或退库订单id
        that.dialogProduct.formData.qualityOrderId = row.id; // 质检订单id
        that.dialogProduct.formData.orderStatus = 1; // 入库状态
        // 处理产品信息
        that.dialogProduct.products = [];
        await that.getProductList();
        const pro = that.productList.find((o) => o.id === row.productTypeInfoId);
        // 这里根据申请单数量生成产品总数，需要人工录入产品id，区分独立设备和包装产品
        // 包装产品时
        const itemRow = {};
        that.setProduct(pro, itemRow);
        itemRow.stockInOutQuantity = row.quantity; // 数量
        itemRow.quantityUnit = pro.unit; // 数量单位
        itemRow.remark = row.remark;
        itemRow.inboundType = row.dataSource === 0 ? '生产' : '退库'; // 入库类型
        itemRow.deviceCode = row.deviceCode; // 出库设备
        that.dialogProduct.products.push(itemRow);
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    async setProduct(productInfo, row) {
        const that = this;
        row.productTypeInfoId = productInfo.id; // 产品id
        row.productInfo = productInfo; // 产品集合
        row.productLine = productInfo.productLine; // 产品线
        row.productType = productInfo.category; // 产品类别
        row.productTypeName = productInfo.category === 0 ? '独立设备' : '包装产品';
        row.deviceCode = ''; // 设备编号 实际
        row.productName = productInfo.productName; // 产品名称
        row.productShortName = productInfo.shortName; // 产品简称
        row.serial = productInfo.serial;
        row.model = productInfo.model;
        row.specifications = productInfo.specifications;
        row.stockInOutQuantity = 1; // 出/库数量默认为1，但是独立设备不运行修改
        row.quantityUnit = productInfo.unit;
    }
    /**
     *  审核质检单
     * @param operType pass、refuse、del
     * @param row
     */
    showAuditFormClick(operType, row) {
        const that = this;
        that.dialogAuditResult.operType = operType;
        that.dialogAuditResult.formData = Object.assign({}, row || {});
        that.dialogAuditResult.visible = true;
        if (operType === 'del') {
            that.dialogAuditResult.title = '作废质检单';
        }
        else if (operType === 'apply') {
            that.dialogAuditResult.title = '重新提交质检申请';
        }
        else if (operType === 'detail') {
            that.dialogAuditResult.title = '查看质检单详情';
        }
        else {
            if (that.dialogAuditResult.formData.examineResult == 0) {
                that.dialogAuditResult.title = '质检单审核';
                // 默认当前用户和时间
                that.dialogAuditResult.formData.examineDate = new Date().format('yyyy-MM-dd');
                that.dialogAuditResult.formData.examineName = (that.userInfo || {}).name; // 获取当前操作人
            }
            else {
                that.dialogAuditResult.title = '质检单重审';
            }
        }
    }
    /**
     * 保存审核表单信息
     */
    async saveAuditFromClick() {
        const that = this;
        if (that.dialogAuditResult.operType === 'del') {
            that.dialogAuditResult.loading = true;
            // 删除事件
            await that.axios
                .delete('/api/erp/order/quality/' + that.dialogAuditResult.formData.id)
                .then((res) => {
                that.dialogAuditResult.loading = false;
                // 提示成功刷新页面
                that.dialogAuditResult.visible = false;
                that.snackbar.success('删除品控质检单成功 ');
                that.getDataList();
            })
                .catch((e) => {
                that.dialogAuditResult.loading = false;
                const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
                that.snackbar.error(`删除品控质检单失败${resMeg}`);
                console.log('删除品控质检单失败', e);
            });
            return true;
        }
        if (!that.$refs['refAuditFormPro'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return false;
        }
        if (that.dialogAuditResult.formData.examineResult == 0) {
            that.snackbar.warn('请选择审核结果.');
            return false;
        }
        // 重新申请时将审核结果置为未审核
        if (that.dialogAuditResult.operType === 'apply') {
            that.dialogAuditResult.formData.examineResult = 0;
        }
        that.dialogAuditResult.loading = true;
        await that.axios
            .put('/api/erp/order/quality/' + that.dialogAuditResult.formData.id, that.dialogAuditResult.formData)
            .then((res) => {
            that.dialogAuditResult.loading = false;
            // 提示成功刷新页面
            that.dialogAuditResult.visible = false;
            that.snackbar.success('审核品控质检单成功 ');
            that.getDataList();
        })
            .catch((e) => {
            that.dialogAuditResult.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`审核品控质检单失败${resMeg}`);
            console.log('审核品控质检单失败', e);
        });
    }
    /**
     * 保存日期时间
     * @param inputType
     */
    handleDateTimeSelection(inputType) {
        const that = this;
        const selectedDate = that.dialogProduct.formData[`${inputType}SelectedDate`];
        const selectedTime = that.dialogProduct.formData[`${inputType}SelectedTime`];
        if (selectedDate && selectedTime) {
            that.dialogProduct.formData[inputType] = `${selectedDate} ${selectedTime}:00`;
            that.dialogProduct.formData[`${inputType}Menu`] = false; // 关闭选择器菜单
        }
    }
    /**
     * 保存库存信息
     */
    async saveProductInventory() {
        const that = this;
        if (!that.$refs['refFormStore'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        that.dialogProduct.loading = true;
        const forms = that.getInventoryFormInfo(that.dialogProduct.formData.storeType, that.dialogProduct.formData);
        await that.axios
            .post('/api/erp/inventory', forms)
            .then(async (res) => {
            that.dialogProduct.loading = false;
            // 提示成功刷新页面
            that.dialogProduct.visible = false;
            // 修改品控质检订单状态
            const url = '/api/erp/order/quality/status/' + that.dialogProduct.formData.qualityOrderId;
            await that.axios
                .put(url, that.dialogProduct.formData)
                .then((qualityRes) => {
                that.snackbar.success('入库成功，并且更新品控订单信息成功');
                that.getDataList();
            })
                .catch((e) => {
                that.dialogOrder.loading = false;
                const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
                that.snackbar.error(`入库成功，并且更新品控订单信息错误${resMeg}`);
                console.log('入库成功，并且更新品控订单信息错误', e);
            });
        })
            .catch((e) => {
            that.dialogProduct.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`入库错误${resMeg}`);
            console.log('入库存错误', e);
        });
    }
    /**
     * 获取库存表单信息
     * storeType :0-入库 1-出库
     */
    getInventoryFormInfo(storeType, formData) {
        const that = this;
        if (!formData)
            return [];
        const forms = [];
        // 这里组装批量入库或出库信息
        that.dialogProduct.products.forEach((item) => {
            // 公共字段
            const data = {
                productLine: item.productLine,
                productTypeInfoId: (item.productInfo || {}).id,
                productType: item.productType,
                productName: item.productName,
                productShortName: item.productShortName,
                serial: item.serial,
                model: item.model,
                specifications: item.specifications,
                stockInOutQuantity: item.stockInOutQuantity,
                remark: formData.remark,
                deviceCode: item.deviceCode,
            };
            if (formData.id)
                data.id = formData.id;
            // 入库
            console.log(formData);
            data.inboundType = item.inboundType;
            data.inboundDate = formData.inboundDate;
            data.salesOrderId = formData.salesOrderId || '';
            data.salesOrderType = formData.salesOrderType;
            data.salesOrderNumber = formData.salesOrderNumber;
            forms.push(data);
        });
        return forms;
    }
    /**
     * 跳转参数处理
     */
    async skipParams() {
        const that = this;
        const params = this.$route.params || {};
        // 存在质检结果，那么就只需处理查询
        if (params.examineResults) {
            that.searchForm.examineResults = params.examineResults.split(',').map(Number);
        }
        if (params.dataSource) {
            that.searchForm.dataSource = that.dataSourceType.find((e) => e.value == params.dataSource) || '';
        }
        if (params.orderStatus) {
            that.searchForm.orderStatus = params.orderStatus;
        }
    }
};
__decorate([
    Getter
], QualityExamine.prototype, "userInfo", void 0);
QualityExamine = __decorate([
    Component({
        name: 'QualityExamine',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], QualityExamine);
export default QualityExamine;
